import {
  AnchorButton as BlueprintAnchorButton,
  AnchorButtonProps as BlueprintAnchorButtonProps,
} from '@blueprintjs/core';
import * as React from 'react';

import {
  Icon,
  IconComponentType,
} from 'bones/design-system/components/icons/Icon';
import { Body } from 'bones/design-system/components/typography/Body';

export type BreadcrumbButtonProps = Pick<
  BlueprintAnchorButtonProps,
  'active' | 'children' | 'disabled' | 'onClick'
> & {
  'data-testid'?: never;
  leftIcon?: IconComponentType;
  testId?: string;
};

export const BreadcrumbButton: React.VFC<BreadcrumbButtonProps> = ({
  active,
  children,
  disabled,
  leftIcon,
  onClick,
  testId,
}) => (
  <BlueprintAnchorButton
    active={active}
    className="vb-breadcrumb-button"
    data-testid={testId}
    disabled={disabled}
    onClick={onClick}
  >
    {leftIcon ? <Icon IconComponent={leftIcon} size="sm" /> : null}
    {children ? (
      <Body ellipsize size="md">
        {children}
      </Body>
    ) : null}
  </BlueprintAnchorButton>
);
